import Vue from "vue";
import Router from "vue-router";
import BuyBoxDetails from "../views/BuyBox/BuyBoxDetails.vue";
import DrrReport from "../views/unicommerce/drrReport.vue";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

//admin views
const AdminDashboard = () => import("@/views/admin/AdminDashboard");
const AdminDashboard2 = () => import("@/views/admin/AdminDashboard2");
const AdminComplianceAutomation = () =>
  import("@/views/admin/AdminComplianceAutomation");
const AdminSQLSync = () => import("@/views/admin/AdminSQLSync");
const AdminDataFixer = () => import("@/views/admin/AdminDataFixer");
const AdminMonitoring = () => import("@/views/admin/AdminMonitoring");
const AdminSentimentVguard = () => import("@/views/admin/AdminSentimentVguard");
const AdminSpiderManagement = () =>
  import("@/views/admin/AdminSpiderManagement");
const AdminSpiderV2 = () => import("@/views/admin/AdminSpiderV2");

//timex
const SOVTimex = () => import("@/views/timex/SOV");
const SOVDetailedTimex = () => import("@/views/timex/SOVDetailed");
const ReviewslistTimex = () => import("@/views/timex/Reviewslist");
const SentimentsTimex = () => import("@/views/timex/Sentiments");
const ComplianceDetailsTimex = () => import("@/views/timex/ComplianceDetails");

//timex_india
const SOVTimexIndia = () => import("@/views/timex_india/SOV");
const SOVDetailedTimexIndia = () => import("@/views/timex_india/SOVDetailed");
const ReviewslistTimexIndia = () => import("@/views/timex_india/Reviewslist");
const SentimentsTimexIndia = () => import("@/views/timex_india/Sentiments");
const PriceTimexIndia = () => import("@/views/timex_india/Price");

//entros
const SOVEntros = () => import("@/views/entros/SOV");
const SOVDetailedEntros = () => import("@/views/entros/SOVDetailed");
const ReviewslistEntros = () => import("@/views/entros/Reviewslist");
const SentimentsEntros = () => import("@/views/entros/Sentiments");

//bosch
const SOVBosch = () => import("@/views/bosch/SOV");
const SOVDetailedBosch = () => import("@/views/bosch/SOVDetailed");
const ReviewslistBosch = () => import("@/views/bosch/Reviewslist");
const SentimentsBosch = () => import("@/views/bosch/Sentiments");

//huggies-demo
const SOVHuggies = () => import("@/views/huggies/SOV");
const SOVDetailedHuggies = () => import("@/views/huggies/SOVDetailed");
const ReviewslistHuggies = () => import("@/views/huggies/Reviewslist");
const SentimentsHuggies = () => import("@/views/huggies/Sentiments");

//hindware-demo
const PriceHindware = () => import("@/views/hindware/PriceHindware");
const DashboardCatIndiaHindware = () =>
  import("@/views/hindware/DashboardCategoryIndia");
const SOVHindware = () => import("@/views/hindware/SOVall4page");
const SOVDetailedHindware = () =>
  import("@/views/hindware/SOVallDetailedIndia");
const ReviewslistHindware = () => import("@/views/hindware/Reviewslist");
const SentimentsHindware = () => import("@/views/hindware/SentimentCatIndia");

//dynamic-demo
const PriceDynamicDemo = () => import("@/views/dynamic_demo/PriceDemo");
const DashboardCatIndiaDynamicDemo = () =>
  import("@/views/dynamic_demo/DashboardCategoryIndia");
const SOVDynamicDemo = () => import("@/views/dynamic_demo/SOVall4page");
const SOVLiteDynamicDemo = () => import("@/views/dynamic_demo/SOVLite");
const SOS3 = () => import("@/views/v3/SOS.vue");
const SosKeywordCompare = () => import("@/views/v3/SosKeywordCompare.vue");
const SOSProductCamp = () => import("@/views/v3/SOSComparison/product.vue");
const Sentiments3 = () => import("@/views/v3/Sentiments.vue");
const SentimentsSummary = () => import("@/views/v3/SentimentsSummary.vue")
const SOSLiteDynamicDemo = () => import("@/views/dynamic_demo/SOSLite");
const SOVDetailedDynamicDemo = () =>
  import("@/views/dynamic_demo/SOVallDetailedIndia");
const SOSDetailedDynamicDemo = () =>
  import("@/views/dynamic_demo/SOSallDetailedIndia");
const ReviewslistDynamicDemo = () => import("@/views/dynamic_demo/Reviewslist");
const SentimentsDynamicDemo = () =>
  import("@/views/dynamic_demo/SentimentCatIndia");
const FormDynamicDemo = () => import("@/views/dynamic_demo/Form");
const demoForm = () => import("@/views/dynamic_demo/CreateDemo/DemoForm");

// global-demo
const PriceGlobalDemo = () => import("@/views/GlobalDemo/PriceDemo");
const DashboardCatIndiaGlobalDemo = () =>
  import("@/views/GlobalDemo/DashboardCategoryIndia");
const SOVGlobalDemo = () => import("@/views/GlobalDemo/SOVall4page");
const SOVDetailedGlobalDemo = () =>
  import("@/views/GlobalDemo/SOVallDetailedIndia");
const ReviewslistGlobalDemo = () => import("@/views/GlobalDemo/Reviewslist");
const SentimentsGlobalDemo = () =>
  import("@/views/GlobalDemo/SentimentCatIndia");

//mothercare-demo
const DashboardCatIndiaMothercare = () =>
  import("@/views/mothercare/DashboardCategoryIndia");
const SOVMothercare = () => import("@/views/mothercare/SOVall4page");
const SOVDetailedMothercare = () =>
  import("@/views/mothercare/SOVallDetailedIndia");
const ReviewslistMothercare = () => import("@/views/mothercare/Reviewslist");
const SentimentsMothercare = () =>
  import("@/views/mothercare/SentimentCatIndia");

//luminous-demo
const DashboardCatIndiaLuminous = () =>
  import("@/views/luminous/DashboardCategoryIndia");
const SOVLuminous = () => import("@/views/luminous/SOVall4page");
const SOVDetailedLuminous = () =>
  import("@/views/luminous/SOVallDetailedIndia");
const ReviewslistLuminous = () => import("@/views/luminous/Reviewslist");
const SentimentsLuminous = () => import("@/views/luminous/SentimentCatIndia");
const PriceLuminous = () => import("@/views/luminous/PriceLuminous");

//nutraj-demo
const DashboardCatIndiaNutraj = () =>
  import("@/views/nutraj/DashboardCategoryIndia");
const SOVNutraj = () => import("@/views/nutraj/SOVall4page");
const SOVDetailedNutraj = () => import("@/views/nutraj/SOVallDetailedIndia");
const ReviewslistNutraj = () => import("@/views/nutraj/Reviewslist");
const SentimentsNutraj = () => import("@/views/nutraj/SentimentCatIndia");

//maharaja-demo
const DashboardCatIndiaMaharaja = () =>
  import("@/views/maharaja/DashboardCategoryIndia");
const SOVMaharaja = () => import("@/views/maharaja/SOVall4page");
const SOVDetailedMaharaja = () =>
  import("@/views/maharaja/SOVallDetailedIndia");
const ReviewslistMaharaja = () => import("@/views/maharaja/Reviewslist");
const SentimentsMaharaja = () => import("@/views/maharaja/SentimentCatIndia");
const PriceMaharaja = () => import("@/views/maharaja/PriceMaharaja");

//beardo-demo
const DashboardCatIndiaBeardo = () =>
  import("@/views/beardo/DashboardCategoryIndia");
const SOVBeardo = () => import("@/views/beardo/SOVall4page");
const SOVDetailedBeardo = () => import("@/views/beardo/SOVallDetailedIndia");
const ReviewslistBeardo = () => import("@/views/beardo/Reviewslist");
const SentimentsBeardo = () => import("@/views/beardo/SentimentCatIndia");
const PriceBeardo = () => import("@/views/beardo/PriceBeardo");

//snapdeal-demo
const DashboardCatIndiaRangita = () =>
  import("@/views/snapdeal/DashboardCategoryIndia");
const SOVRangita = () => import("@/views/snapdeal/SOVall4page");
const SOVDetailedRangita = () => import("@/views/snapdeal/SOVallDetailedIndia");
const ReviewslistRangita = () => import("@/views/snapdeal/Reviewslist");
const SentimentsRangita = () => import("@/views/snapdeal/SentimentCatIndia");

//kenstar-demo
const DashboardCatIndiaKenstar = () =>
  import("@/views/kenstar/DashboardCategoryIndia");
const SOVKenstar = () => import("@/views/kenstar/SOVall4page");
const SOVDetailedKenstar = () => import("@/views/kenstar/SOVallDetailedIndia");
const ReviewslistKenstar = () => import("@/views/kenstar/Reviewslist");
const SentimentsKenstar = () => import("@/views/kenstar/SentimentCatIndia");
const PriceKenstar = () => import("@/views/kenstar/Price");

//seagate demo
const DashboardCatIndiaSeagate = () =>
  import("@/views/seagate/DashboardCategoryIndia");
const SOVSeagate = () => import("@/views/seagate/SOVall4page");
const SOVDetailedSeagate = () => import("@/views/seagate/SOVallDetailedIndia");
const ReviewslistSeagate = () => import("@/views/seagate/Reviewslist");
const SentimentsSeagate = () => import("@/views/seagate/SentimentCatIndia");

//trident demo
const DashboardCatIndiaTrident = () =>
  import("@/views/MyTrident/DashboardCategoryIndia");
const SOVTrident = () => import("@/views/MyTrident/SOVall4page");
const SOVDetailedTrident = () =>
  import("@/views/MyTrident/SOVallDetailedIndia");
const ReviewslistTrident = () => import("@/views/MyTrident/Reviewslist");
const SentimentsTrident = () => import("@/views/MyTrident/SentimentCatIndia");

//urbanmark-demo
const DashboardCatIndiaUrbanmark = () =>
  import("@/views/urbanmark/DashboardCategoryIndia");
const SOVUrbanmark = () => import("@/views/urbanmark/SOVall4page");
const SOVDetailedUrbanmark = () =>
  import("@/views/urbanmark/SOVallDetailedIndia");
const ReviewslistUrbanmark = () => import("@/views/urbanmark/Reviewslist");
const SentimentsUrbanmark = () => import("@/views/urbanmark/SentimentCatIndia");

//vjprime
const SOVVjprime = () => import("@/views/vjprime/SOV");
const SOVDetailedVjprime = () => import("@/views/vjprime/SOVDetailed");
const ReviewslistVjprime = () => import("@/views/vjprime/Reviewslist");
const SentimentsVjprime = () => import("@/views/vjprime/Sentiments");

//sirona
const SOVsirona = () => import("@/views/sirona_demo/SOV");
const SOVDetailedsirona = () => import("@/views/sirona_demo/SOVDetailed");
const Reviewslistsirona = () => import("@/views/sirona_demo/Reviewslist");
const Sentimentssirona = () => import("@/views/sirona_demo/Sentiments");

//mcafee
const SOVMcafee = () => import("@/views/mcafee/SOV");
const SOVDetailedMcafee = () => import("@/views/mcafee/SOVDetailed");
const ReviewslistMcafee = () => import("@/views/mcafee/Reviewslist");
const SentimentsMcafee = () => import("@/views/mcafee/Sentiments");
const ComplianceDetailsMcafee = () =>
  import("@/views/mcafee/ComplianceDetails");

//ucb - united color of benetton
const PriceUCB = () => import("@/views/ucb/PriceUCB");

//AMD India New View
const SentimentsAmdIndia = () => import("@/views/amdIndia/SentimentsAmdIndia");
const SOVDetailedamdIndia = () =>
  import("@/views/amdIndia/SOVDetailedamdIndia");
const SOVamdIndia = () => import("@/views/amdIndia/SOVamdIndia");
const SOVDetailNewAMDIndia = () => import("@/views/amdIndia/SOVDetailNew");
const ComplianceDetailsAMDIndia = () =>
  import("@/views/amdIndia/ComplianceDetails");
const ComplianceReportAMDIndia = () =>
  import("@/views/amdIndia/ComplianceReport");
const ComplianceMessagingReportAMDIndia = () =>
  import("@/views/amdIndia/ComplianceMessagingReport");
const SOVDetailedOEMAMDIndia = () => import("@/views/amdIndia/SOVDetailed");
const ReviewslistAMDIndia = () => import("@/views/amdIndia/Reviewslist");
const SentimentsAmdIndiaOEM = () => import("@/views/amdIndia/Sentiments");

//Demo
const SentimentsDemo = () => import("@/views/demo/Sentiments");
const SOVDetailedDemo = () => import("@/views/demo/SOVDetailed");
const SOVDemo = () => import("@/views/demo/SOV");
const SOVDetailNewDemo = () => import("@/views/demo/SOVDetailNew");
const ComplianceDetailsDemo = () => import("@/views/demo/ComplianceDetails");
const ComplianceReportDemo = () => import("@/views/demo/ComplianceReport");
const ComplianceMessagingReportDemo = () =>
  import("@/views/demo/ComplianceMessagingReport");
const SOVDetailedOEMDemo = () => import("@/views/demo/SOVDetailedOEM");
const ReviewslistDemo = () => import("@/views/demo/Reviewslist");
const SentimentsOEMDemo = () => import("@/views/demo/SentimentsOEM");
const PriceDemo = () => import("@/views/demo/Price");

//bosch_trial
const SOVall4PageBoschTrial = () => import("@/views/bosch_trial/SOVall4page");
const SOVallDetailIndiaBoschTrial = () =>
  import("@/views/bosch_trial/SOVallDetailedIndia");

//vstar_india
const SOVall4PageVStar = () => import("@/views/vstar/SOVall4page");
const SOVallDetailIndiaVStar = () =>
  import("@/views/vstar/SOVallDetailedIndia");

// AMD global, and all other Views
const Dashboard = () => import("@/views/Dashboard");
const DashboardVguard = () => import("@/views/DashboardVguard");
const DashboardCat = () => import("@/views/DashboardCategory");
const DashboardCatIndia = () => import("@/views/DashboardCategoryIndia");
const Sentiment = () => import("@/views/Sentiment");
const SentimentVguard = () => import("@/views/SentimentVguard");
const ComplaintsVguard = () => import("@/views/ComplaintsVguard2");
const SentimentCat = () => import("@/views/SentimentCat");
const SentimentCatIndia = () => import("@/views/SentimentCatIndia");
const Sentiments = () => import("@/views/Sentiments");
const Reviewslist = () => import("@/views/Reviewslist");
const ReviewslistAll = () => import("@/views/ReviewslistAll");

const Youtube = () => import("@/views/Youtube");
const Price = () => import("@/views/Price");
const PriceFunFood = () => import("@/views/PriceFunFood");
const PricePhilips = () => import("@/views/PricePhilips");
const Forums = () => import("@/views/Forums");
const SOV = () => import("@/views/SOV");

const SOV2 = () => import("@/views/SOV2");
const SOV3 = () => import("@/views/SOV3");
const SOV4 = () => import("@/views/SOV4");
const SOV5 = () => import("@/views/SOV5");
const SOVall = () => import("@/views/SOVall");
const SOVall4Page = () => import("@/views/SOVall4page");
const SOVallDetail = () => import("@/views/SOVallDetailed");
const SOVallDetailIndia = () => import("@/views/SOVallDetailedIndia");
const SOVnesplus = () => import("@/views/SOVnesplus");
const SOVDetailed = () => import("@/views/SOVDetailed");
const SOVDetailNew = () => import("@/views/SOVDetailNew");

const SOVDetailReport = () => import("@/views/SOVDetailReport");

const SOVReport = () => import("@/views/SOVReport");
const SOVDetail = () => import("@/views/SOV2Detailed");
const SOV3Detail = () => import("@/views/SOV3Detailed");
const SOV4Detail = () => import("@/views/SOV4Detailed");
const SOV5Detail = () => import("@/views/SOV5Detailed");
const SOVnesplusDetail = () => import("@/views/SOVnesplusDetailed");
const ComplianceDetails = () => import("@/views/ComplianceDetails");
const ComplianceReport = () => import("@/views/ComplianceReport");
const ComplianceMessagingReport = () =>
  import("@/views/ComplianceMessagingReport");
const Audit = () => import("@/views/Audit");

const Colors = () => import("@/views/theme/Colors");
const Typography = () => import("@/views/theme/Typography");

const Charts = () => import("@/views/Charts");
const Widgets = () => import("@/views/Widgets");

// Views - Components
const Cards = () => import("@/views/base/Cards");
const Forms = () => import("@/views/base/Forms");
const Switches = () => import("@/views/base/Switches");
const Tables = () => import("@/views/base/Tables");
const Tabs = () => import("@/views/base/Tabs");
const Breadcrumbs = () => import("@/views/base/Breadcrumbs");
const Carousels = () => import("@/views/base/Carousels");
const Collapses = () => import("@/views/base/Collapses");
const Jumbotrons = () => import("@/views/base/Jumbotrons");
const ListGroups = () => import("@/views/base/ListGroups");
const Navs = () => import("@/views/base/Navs");
const Navbars = () => import("@/views/base/Navbars");
const Paginations = () => import("@/views/base/Paginations");
const Popovers = () => import("@/views/base/Popovers");
const ProgressBars = () => import("@/views/base/ProgressBars");
const Tooltips = () => import("@/views/base/Tooltips");

// Views - Buttons
const StandardButtons = () => import("@/views/buttons/StandardButtons");
const ButtonGroups = () => import("@/views/buttons/ButtonGroups");
const Dropdowns = () => import("@/views/buttons/Dropdowns");
const BrandButtons = () => import("@/views/buttons/BrandButtons");

// Views - Icons
const Flags = () => import("@/views/icons/Flags");
const FontAwesome = () => import("@/views/icons/FontAwesome");
const SimpleLineIcons = () => import("@/views/icons/SimpleLineIcons");
const CoreUIIcons = () => import("@/views/icons/CoreUIIcons");

// Views - Notifications
const Alerts = () => import("@/views/notifications/Alerts");
const Badges = () => import("@/views/notifications/Badges");
const Modals = () => import("@/views/notifications/Modals");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");
const ForgetPassword = () => import("@/views/pages/forget");
const Registration = () => import("@/views/pages/Registration");
const Recovery = () => import("@/views/pages/recovery");
// Users
const Users = () => import("@/views/users/Users");
const User = () => import("@/views/users/User");

// Lqs Analyser
const LqsAnalyser = () => import("@/views/LqsAnalyser/LqsAnalyser");
const ASINsDetailed = () => import("@/views/LqsAnalyser/ASINsDetailed");
const FSNsDetailed = () => import("@/views/LqsAnalyser/Flipkart/FSNsDetailed");
const ASINsCompare = () => import("@/views/LqsAnalyser/ASINsCompare");
// const MyProducts = () => import("@/views/LqsAnalyser/MyProducts");
const LqsSchedule = () => import("@/views/LqsAnalyser/LqsSchedule");
const ViewLqsRequest = () => import("@/views/LqsAnalyser/ViewLqsRequest");
const ReqASINsDetailed = () => import("@/views/LqsAnalyser/ReqASINsDetailed");
const ReqFSNsDetailed = () =>
  import("@/views/LqsAnalyser/Flipkart/ReqFSNsDetailed");

const FSNsCompare = () => import("@/views/LqsAnalyser/Flipkart/FSNsCompare");

//Lqs Analyser Global
const LqsAnalyserGlobal = () =>
  import("@/views/GlobalDemo/LqsAnalyserGlobal/LqsAnalyser");
const ASINsDetailedGlobal = () =>
  import("@/views/GlobalDemo/LqsAnalyserGlobal/ASINsDetailed");
const MyASINsGlobal = () =>
  import("@/views/GlobalDemo/LqsAnalyserGlobal/MyASINs");
const ReqASINsDetailedGlobal = () =>
  import("@/views/GlobalDemo/LqsAnalyserGlobal/ReqASINsDetailed");

//IndiaGate Dashboard
const IndiaGateDashboard = () =>
  import("@/views/indiagate_dashboard/Dashboard");
const PriceTracking = () => import("@/views/indiagate_dashboard/PriceTracking");
const PriceTrackingDisparity = () =>
  import("@/views/indiagate_dashboard/PriceTrackingDisparity");
const DisparityDetailsPage = () =>
  import("@/views/indiagate_dashboard/DisparityDetailsPage");
const PriceTrackingCompare = () =>
  import("@/views/indiagate_dashboard/PriceTrackingCompare");

//Keyword Tracker
const KeywordTracker = () => import("@/views/keyword_tracker/KeywordTracker");

// Buy Box Monitor
const BuyBoxMonitor = () => import("@/views/BuyBox/BuyBoxMonitor");

// Phrase Analyzer
const PhraseAnalyser = () => import("@/views/PhraseAnalyser/PhraseAnalyser");

const ProfileDetail = () => import("@/views/Profile/profileDetail");
const UserManagement = () => import("@/views/user_management/UserManagement");
const UserRegister = () => import("@/views/user_management/UserRegister");
const userLogs = () => import("@/views/user_management/userLogs");
// Reviews and Ratings
const ReviewSummary = () => import("@/views/ReviewsAndRatings/Summary.vue");
const BrandReviews = () => import("@/views/ReviewsAndRatings/BrandReviews");
const CategoryReviews = () =>
  import("@/views/ReviewsAndRatings/CategoryReviews");
const ProductReviews = () => import("@/views/ReviewsAndRatings/ProductReviews");
const newProductReviews = () =>
  import("@/views/ReviewsAndRatings/newProductReviews");
const ProductSentiments = () =>
  import("@/views/Sentiments/ProductSentiments.vue");

// slate
// const SlateAMS = () => import("@/views/Slate/AMS/AMS.vue");
const SlateAMS = () => import("@/views/Slate/AMS/AMS.vue");
const CustomReport = () =>
  import("@/views/Slate/CustomReport/CustomReportWrapper.vue");
const DynamicReport = () =>
  import("@/views/Slate/CustomReport/DynamicReport.vue");

// const AMSAnalytics = () => import("@/views/Slate/AMS/AMSAnalytics.vue");
const Alert = () => import("@/views/Slate/Alert/Alert.vue");
// const SlateSummary = () => import("@/views/Slate/Search/AmazonSearch.vue");
const PerformanceSummary = () =>
  import("@/views/Slate/Sleepwell/Sleepwell.vue");
const PlugNPlay = () => import("@/views/Slate/PlugNPlay/PlugNPlay.vue");
const Accounts = () => import("@/views/Slate/PlugNPlay/AccountList.vue");
const CampaignSummary = () =>
  import("@/views/Slate/CampaignSummary/CampaignSummary.vue");
const ConnectionSuccessful = () =>
  import("@/views/Slate/PlugNPlay/connectedSuccessfully.vue");
const ConnectionFailed = () =>
  import("@/views/Slate/PlugNPlay/connectionfail.vue");

// Inventory Pages
const VendorSummary = () => import("@/views/Inventory/VendorSummary.vue");
const FCSummary = () => import("@/views/Inventory/FCSummary.vue");
// inventory management
const warehouseSummary = () =>
  import("@/views/warehouseManagement/warehouseSummary.vue");

// pegasus
const unicommerceSummary = () => import("@/views/unicommerce/summary.vue");
const totalOrders = () => import("@/views/unicommerce/totalOrders.vue");
const grnReco = () => import("@/views/unicommerce/grnReco.vue");
const stockPlanningSummary = () => import("@/views/unicommerce/stockPlaningSummary.vue");
const drrReport = () => import("@/views/unicommerce/drrReport.vue");
const allUploadFile = () => import ("@/views/unicommerce/allUploadFile.vue")
const GenAiAsideBar =()=> import("@/views/v3/GenAi/GenAiAsideBar.vue");

//reports
const ReportSection = () => import("@/views/reports/ReportSection.vue");

Vue.use(Router);

function configRoutes() {
  return [
    {
      path: "/",
      name: "Login",
      component: Login,
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
    },
    {
      path: "/forget-password",
      name: "Forget",
      component: ForgetPassword,
    },
    {
      path: "/recovery/:token",
      name: "Recovery",
      component: Recovery,
    },
    {
      path: "/registration-form",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Features",
          component: Registration,
        },
      ],
    },
    {
      path: "/invite/:token",
      name: "User Register",
      component: UserRegister,
    },
    
    {
      path: "/dashboard",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Dashboard",
          component: Dashboard,
        },
      ],
    },
    {
      path: "/admin-monitoring",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Spider Monitor",
          component: AdminMonitoring,
        },
      ],
    },
    {
      path: "/admin-spiders-management",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Spider Management",
          component: AdminSpiderManagement,
        },
      ],
    },
    {
      path: "/admin-spiders-v2",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "AdminSpiderV2",
          component: AdminSpiderV2,
        },
      ],
    },
    {
      path: "/admin-dashboard",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Admin Dashboard",
          component: AdminDashboard,
        },
      ],
    },
    {
      path: "/admin-dashboard-new",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Compliance",
          component: AdminDashboard2,
        },
      ],
    },
    {
      path: "/compliance-automation",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Compliance Automation",
          component: AdminComplianceAutomation,
        },
      ],
    },
    {
      path: "/sql-sync",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SQL Sync",
          component: AdminSQLSync,
        },
      ],
    },
    {
      path: "/admin-data-fixer",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "AdminDataFixer",
          component: AdminDataFixer,
        },
      ],
    },
    {
      path: "/dashboard-category",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "DashboardCat",
          component: DashboardCat,
        },
      ],
    },
    {
      path: "/dashboard-category-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "DashboardCatIndia",
          component: DashboardCatIndia,
        },
      ],
    },
    {
      path: "/dashboard-category-hindware",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "DashboardCatIndia",
          component: DashboardCatIndiaHindware,
        },
      ],
    },
    {
      path: "/dashboard-category/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Product Reviews",
          component: DashboardCatIndiaDynamicDemo,
        },
      ],
    },
    {
      path: "/global-dashboard-category/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Dashboard",
          component: DashboardCatIndiaGlobalDemo,
        },
      ],
    },
    {
      path: "/dashboard-category-mothercare",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "DashboardCatIndia",
          component: DashboardCatIndiaMothercare,
        },
      ],
    },
    {
      path: "/dashboard-category-luminous",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Reviews and Ratings",
          component: DashboardCatIndiaGlobalDemo,
        },
      ],
    },
    {
      path: "/dashboard-category-nutraj",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "DashboardCatIndia",
          component: DashboardCatIndiaNutraj,
        },
      ],
    },
    {
      path: "/dashboard-category-maharaja",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "DashboardCatIndiaMaharajas",
          component: DashboardCatIndiaMaharaja,
        },
      ],
    },
    {
      path: "/dashboard-category-beardo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "DashboardCatIndiabeardo",
          component: DashboardCatIndiaBeardo,
        },
      ],
    },
    {
      path: "/dashboard-category-rangita",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Dashboard",
          component: DashboardCatIndiaRangita,
        },
      ],
    },
    {
      path: "/dashboard-category-kenstar",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Dashboard",
          component: DashboardCatIndiaKenstar,
        },
      ],
    },
    {
      path: "/dashboard-category-seagate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "DashboardCatIndia",
          component: DashboardCatIndiaSeagate,
        },
      ],
    },
    {
      path: "/dashboard-category-trident",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "DashboardCatIndia",
          component: DashboardCatIndiaTrident,
        },
      ],
    },
    {
      path: "/dashboard-category-urbanmark",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "DashboardCatIndia",
          component: DashboardCatIndiaUrbanmark,
        },
      ],
    },
    {
      path: "/sentiment",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Sentiment",
          component: Sentiment,
        },
      ],
    },
    {
      path: "/sentiment-category",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SentimentCat",
          component: SentimentCat,
        },
      ],
    },
    {
      path: "/sentiment-category-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SentimentCatIndia",
          component: SentimentCatIndia,
        },
      ],
    },
    {
      path: "/youtube",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Youtube",
          component: Youtube,
        },
      ],
    },
    {
      path: "/price",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Price",
          component: Price,
        },
      ],
    },
    {
      path: "/price-funfoods",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "PriceFunFood",
          component: PriceFunFood,
        },
      ],
    },
    {
      path: "/price-hindware",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "PriceHindware",
          component: PriceHindware,
        },
      ],
    },
    {
      path: "/price-maharaja",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "PriceMaharaja",
          component: PriceMaharaja,
        },
      ],
    },
    {
      path: "/price-beardo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "PriceBeardo",
          component: PriceBeardo,
        },
      ],
    },
    {
      path: "/price-kenstar",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Price",
          component: PriceKenstar,
        },
      ],
    },
    {
      path: "/price/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "PriceDemo",
          component: PriceDynamicDemo,
        },
      ],
    },
    {
      path: "/global-price/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Market Explorer",
          component: PriceGlobalDemo,
        },
      ],
    },
    {
      path: "/price-luminous",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "PriceLuminous",
          component: PriceLuminous,
        },
      ],
    },
    {
      path: "/price-philips",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "PricePhilips",
          component: PricePhilips,
        },
      ],
    },
    {
      path: "/price-ucb",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "PriceUCB",
          component: PriceUCB,
        },
      ],
    },
    {
      path: "/price-timex-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Pricetimexindia",
          component: PriceTimexIndia,
        },
      ],
    },
    {
      path: "/forums",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Forums",
          component: Forums,
        },
      ],
    },
    {
      path: "/sov",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Summary",
          component: SOV,
        },
      ],
    },
    {
      path: "/sov-timex",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovtimex",
          component: SOVTimex,
        },
      ],
    },
    {
      path: "/sov-timex-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovtimexindia",
          component: SOVTimexIndia,
        },
      ],
    },
    {
      path: "/sov-entros",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "soventros",
          component: SOVEntros,
        },
      ],
    },
    {
      path: "/sov-bosch",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovbosch",
          component: SOVBosch,
        },
      ],
    },
    {
      path: "/sov-hindware",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovhindware",
          component: SOVHindware,
        },
      ],
    },
    {
      path: "/sov/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Share of Voice",
          component: SOVDynamicDemo,
        },
      ],
    },
    {
      path: "/sov-new",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Share of Voice",
          component: SOVLiteDynamicDemo,
        },
      ],
    },
    {
      path: "/v-sos",
      component: DefaultContainer,
      children: [
        {
          path: "/v-sos",
          name: "Share of Search",
          component: SOS3,
        },
        {
          path: "/sos-compare",
          name: "Share of Search",
          component: SosKeywordCompare,
        },{
          path: "/product",
          name: "Product ",
          component: SOSProductCamp,
        }
      ],
    },
    {
      path: "/v-sentiments",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Sentiments",
          component: Sentiments3,
        },
      ],
    },
    {
      path: "/reports-section",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Reports",
          component: ReportSection,
        },
      ],
    },
    {
      path: "/sentiments-summary",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Sentiments",
          component: SentimentsSummary,
        },
      ],
    },
    {
      path: "/share-of-search",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Summary",
          component: SOSLiteDynamicDemo,
        },
      ],
    },
    {
      path: "/global-sov/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Summary",
          component: SOVGlobalDemo,
        },
      ],
    },
    {
      path: "/sov-mothercare",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovmothercare",
          component: SOVMothercare,
        },
      ],
    },
    {
      path: "/sov-luminous",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Share of Voice",
          component: SOVGlobalDemo,
        },
      ],
    },
    {
      path: "/sov-nutraj",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovnutraj",
          component: SOVNutraj,
        },
      ],
    },
    {
      path: "/sov-maharaja",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovmaharaja",
          component: SOVMaharaja,
        },
      ],
    },
    {
      path: "/sov-Beardo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVBeardo",
          component: SOVBeardo,
        },
      ],
    },
    {
      path: "/sov-rangita",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Summary",
          component: SOVRangita,
        },
      ],
    },
    {
      path: "/sov-kenstar",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Summary",
          component: SOVKenstar,
        },
      ],
    },
    {
      path: "/sov-seagate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovseagate",
          component: SOVSeagate,
        },
      ],
    },
    {
      path: "/sov-trident",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovtrident",
          component: SOVTrident,
        },
      ],
    },
    {
      path: "/sov-urbanmark",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovurbanmark",
          component: SOVUrbanmark,
        },
      ],
    },
    {
      path: "/sov-Huggies",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovbosch",
          component: SOVHuggies,
        },
      ],
    },
    {
      path: "/sov-vjprime",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovvjprime",
          component: SOVVjprime,
        },
      ],
    },
    {
      path: "/sov-sirona",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovsirona",
          component: SOVsirona,
        },
      ],
    },
    {
      path: "/reviewslist-timex",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslisttimex",
          component: ReviewslistTimex,
        },
      ],
    },
    {
      path: "/reviewslist-timex-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslisttimexindia",
          component: ReviewslistTimexIndia,
        },
      ],
    },
    {
      path: "/reviewslist-entros",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslistEntros",
          component: ReviewslistEntros,
        },
      ],
    },
    {
      path: "/reviewslist-bosch",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslistBosch",
          component: ReviewslistBosch,
        },
      ],
    },
    {
      path: "/reviewslist-vjprime",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslistvjprime",
          component: ReviewslistVjprime,
        },
      ],
    },
    {
      path: "/reviewslist-huggies",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslisthuggies",
          component: ReviewslistHuggies,
        },
      ],
    },
    {
      path: "/reviewslist-hindware",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslisthidware",
          component: ReviewslistHindware,
        },
      ],
    },
    {
      path: "/reviewslist/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Reviews",
          component: ReviewslistDynamicDemo,
        },
      ],
    },
    {
      path: "/global-reviewslist/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Reviews",
          component: ReviewslistGlobalDemo,
        },
      ],
    },
    {
      path: "/reviewslist-mothercare",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslistmothercare",
          component: ReviewslistMothercare,
        },
      ],
    },
    {
      path: "/reviewslist-luminous",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslistluminous",
          component: ReviewslistLuminous,
        },
      ],
    },
    {
      path: "/reviewslist-nutraj",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslistnutraj",
          component: ReviewslistNutraj,
        },
      ],
    },
    {
      path: "/reviewslist-maharaja",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslistmaharaja",
          component: ReviewslistMaharaja,
        },
      ],
    },
    {
      path: "/reviewslist-beardo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "ReviewslistBeardo",
          component: ReviewslistBeardo,
        },
      ],
    },
    {
      path: "/reviewslist-rangita",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Reviews",
          component: ReviewslistRangita,
        },
      ],
    },
    {
      path: "/reviewslist-kenstar",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Reviews",
          component: ReviewslistKenstar,
        },
      ],
    },
    {
      path: "/reviewslist-seagate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslistseagate",
          component: ReviewslistSeagate,
        },
      ],
    },
    {
      path: "/reviewslist-trident",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslisttrident",
          component: ReviewslistTrident,
        },
      ],
    },
    {
      path: "/reviewslist-urbanmark",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslisturbanmark",
          component: ReviewslistUrbanmark,
        },
      ],
    },
    {
      path: "/reviewslist-sirona",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslistsirona",
          component: Reviewslistsirona,
        },
      ],
    },
    {
      path: "/sov-mcafee",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovmcafee",
          component: SOVMcafee,
        },
      ],
    },
    {
      path: "/reviewslist-mcafee",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "reviewslistmcafee",
          component: ReviewslistMcafee,
        },
      ],
    },
    {
      path: "/sov-summary",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovsummary",
          component: SOV2,
        },
      ],
    },
    {
      path: "/sov-summary-plantronics",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovsummaryplantronics",
          component: SOV3,
        },
      ],
    },
    {
      path: "/sov-summary-funfoods",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovsummaryfunfoods",
          component: SOV4,
        },
      ],
    },
    {
      path: "/sov-summary-dabur",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovsummarydabur",
          component: SOV5,
        },
      ],
    },
    {
      path: "/sov-summary-amd",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Summary",
          component: SOVamdIndia,
        },
      ],
    },
    {
      path: "/sov-summary-nesplus",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovsummarynesplus",
          component: SOVnesplus,
        },
      ],
    },
    {
      path: "/sov-dashboard",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVall",
          component: SOVall,
        },
      ],
    },
    {
      path: "/dashboard-sov",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVall4Page",
          component: SOVall4Page,
        },
      ],
    },
    {
      path: "/dashboard-sov-vstar",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVall4PageVStar",
          component: SOVall4PageVStar,
        },
      ],
    },
    {
      path: "/dashboard-sov-bosch-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVall4PageBoschTrial",
          component: SOVall4PageBoschTrial,
        },
      ],
    },
    {
      path: "/sov-detailed-all",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVallDetail",
          component: SOVallDetail,
        },
      ],
    },
    {
      path: "/sov-detailed-all-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVallDetailIndia",
          component: SOVallDetailIndia,
        },
      ],
    },
    {
      path: "/sov-detailed-vstar",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVallDetailIndiaVStar",
          component: SOVallDetailIndiaVStar,
        },
      ],
    },
    {
      path: "/sov-detailed-bosch-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVallDetailIndiaBoschTrial",
          component: SOVallDetailIndiaBoschTrial,
        },
      ],
    },
    {
      path: "/sov-detailed",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Listing Details ",
          component: SOVDetailed,
        },
      ],
    },
    {
      path: "/sov-detailed-amd-india-oem",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Listing Details OEM",
          component: SOVDetailedOEMAMDIndia,
        },
      ],
    },
    {
      path: "/sov-detailed-timex",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedtimex",
          component: SOVDetailedTimex,
        },
      ],
    },
    {
      path: "/sov-detailed-timex-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedtimexindia",
          component: SOVDetailedTimexIndia,
        },
      ],
    },
    {
      path: "/sov-detailed-entros",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedentros",
          component: SOVDetailedEntros,
        },
      ],
    },
    {
      path: "/sov-detailed-bosch",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedbosch",
          component: SOVDetailedBosch,
        },
      ],
    },
    {
      path: "/sov-detailed-huggies",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedhuggies",
          component: SOVDetailedHuggies,
        },
      ],
    },
    {
      path: "/sov-detailed-hindware",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedhhindware",
          component: SOVDetailedHindware,
        },
      ],
    },
    {
      path: "/sov-detailed/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOV Detailed",
          component: SOVDetailedDynamicDemo,
        },
      ],
    },
    {
      path: "/sos-detailed/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOS Detailed",
          component: SOSDetailedDynamicDemo,
        },
      ],
    },
    {
      path: "/global-sov-detailed/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Listing Details",
          component: SOVDetailedGlobalDemo,
        },
      ],
    },
    {
      path: "/sov-detailed-mothercare",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Listing Details",
          component: SOVDetailedDynamicDemo,
        },
      ],
    },

    {
      path: "/sov-detailed-luminous",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedhluminous",
          component: SOVDetailedLuminous,
        },
      ],
    },
    {
      path: "/sov-detailed-nutraj",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedhnutraj",
          component: SOVDetailedNutraj,
        },
      ],
    },
    {
      path: "/sov-detailed-maharaja",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedhmaharaja",
          component: SOVDetailedMaharaja,
        },
      ],
    },
    {
      path: "/sov-detailed-beardo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVDetailedBeardo",
          component: SOVDetailedBeardo,
        },
      ],
    },
    {
      path: "/sov-detailed-rangita",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Listing Details",
          component: SOVDetailedRangita,
        },
      ],
    },
    {
      path: "/sov-detailed-kenstar",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Listing Details",
          component: SOVDetailedKenstar,
        },
      ],
    },
    {
      path: "/sov-detailed-seagate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedhseagate",
          component: SOVDetailedSeagate,
        },
      ],
    },
    {
      path: "/sov-detailed-trident",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedhtrident",
          component: SOVDetailedTrident,
        },
      ],
    },
    {
      path: "/sov-detailed-urbanmark",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedhurbanmark",
          component: SOVDetailedUrbanmark,
        },
      ],
    },
    {
      path: "/sov-detailed-vjprime",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedvjprime",
          component: SOVDetailedVjprime,
        },
      ],
    },
    {
      path: "/sov-detailed-sirona",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedsirona",
          component: SOVDetailedsirona,
        },
      ],
    },
    {
      path: "/sov-detailed-mcafee",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetailedmcafee",
          component: SOVDetailedMcafee,
        },
      ],
    },
    {
      path: "/sovdetailed",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOV Details",
          component: SOVDetailNew,
        },
      ],
    },
    {
      path: "/sovdetailed-amd-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVDetailNewAMDIndia",
          component: SOVDetailNewAMDIndia,
        },
      ],
    },
    {
      path: "/sov-detail-report",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOV Detail Report",
          component: SOVDetailReport,
        },
      ],
    },
    {
      path: "/sov-detailed-amd",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Listing Details",
          component: SOVDetailedamdIndia,
        },
      ],
    },
    {
      path: "/sov-report",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOV Report",
          component: SOVReport,
        },
      ],
    },
    {
      path: "/sov-detailed-plantronics",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sov3detailed",
          component: SOV3Detail,
        },
      ],
    },
    {
      path: "/sov-detailed-funfoods",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sov4detailed",
          component: SOV4Detail,
        },
      ],
    },
    {
      path: "/sov-detailed-dabur",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sov5detailed",
          component: SOV5Detail,
        },
      ],
    },
    {
      path: "/sov-detailed-nesplus",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovnesplusdetailed",
          component: SOVnesplusDetail,
        },
      ],
    },
    {
      path: "/sov-detail",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sovdetail",
          component: SOVDetail,
        },
      ],
    },
    {
      path: "/compliance-detail",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Compliance Details",
          component: ComplianceDetails,
        },
      ],
    },
    {
      path: "/compliance-detail-amd-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Compliance Details",
          component: ComplianceDetailsAMDIndia,
        },
      ],
    },
    {
      path: "/compliance-detail-mcafee",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "compliancedetailsmcafee",
          component: ComplianceDetailsMcafee,
        },
      ],
    },
    {
      path: "/compliance-report",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Nomenclature Report",
          component: ComplianceReport,
        },
      ],
    },
    {
      path: "/compliance-report-amd-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Nomenclature Report",
          component: ComplianceReportAMDIndia,
        },
      ],
    },
    {
      path: "/messaging-report",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Messaging Report",
          component: ComplianceMessagingReport,
        },
      ],
    },
    {
      path: "/messaging-report-amd-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Messaging Report",
          component: ComplianceMessagingReportAMDIndia,
        },
      ],
    },
    {
      path: "/sentiments",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Sentiments",
          component: Sentiments,
        },
      ],
    },
    {
      path: "/sentiments-mcafee",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentsmcafee",
          component: SentimentsMcafee,
        },
      ],
    },
    {
      path: "/sentiments-timex",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentstimex",
          component: SentimentsTimex,
        },
      ],
    },
    {
      path: "/sentiments-timex-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentstimexindia",
          component: SentimentsTimexIndia,
        },
      ],
    },
    {
      path: "/sentiments-entros",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentsentros",
          component: SentimentsEntros,
        },
      ],
    },
    {
      path: "/sentiments-bosch",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentsbosch",
          component: SentimentsBosch,
        },
      ],
    },
    {
      path: "/sentiments-huggies",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentshuggies",
          component: SentimentsHuggies,
        },
      ],
    },
    {
      path: "/sentiments-hindware",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentshindware",
          component: SentimentsHindware,
        },
      ],
    },
    {
      path: "/sentiments/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Sentiments",
          component: SentimentsDynamicDemo,
        },
      ],
    },
    {
      path: "/global-sentiments/:client",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Sentiments",
          component: SentimentsGlobalDemo,
        },
      ],
    },
    {
      path: "/demo-form",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Setting up your account",
          component: demoForm,
        },
      ],
    },
    {
      path: "/sentiments-mothercare",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentsmothercare",
          component: SentimentsMothercare,
        },
      ],
    },
    {
      path: "/sentiments-luminous",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentsluminous",
          component: SentimentsLuminous,
        },
      ],
    },
    {
      path: "/sentiments-nutraj",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentsnutraj",
          component: SentimentsNutraj,
        },
      ],
    },
    {
      path: "/sentiments-maharaja",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentsmaharaja",
          component: SentimentsMaharaja,
        },
      ],
    },
    {
      path: "/sentiments-beardo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SentimentsBeardo",
          component: SentimentsBeardo,
        },
      ],
    },
    {
      path: "/sentiments-rangita",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Sentiments",
          component: SentimentsRangita,
        },
      ],
    },
    {
      path: "/sentiments-kenstar",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Sentiments",
          component: SentimentsKenstar,
        },
      ],
    },
    {
      path: "/sentiments-seagate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentsseagate",
          component: SentimentsSeagate,
        },
      ],
    },
    {
      path: "/sentiments-trident",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentstrident",
          component: SentimentsTrident,
        },
      ],
    },
    {
      path: "/sentiments-urbanmark",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentsurbanmark",
          component: SentimentsUrbanmark,
        },
      ],
    },
    {
      path: "/sentiments-vjprime",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentsvjprime",
          component: SentimentsVjprime,
        },
      ],
    },
    {
      path: "/sentiments-sirona",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentssirona",
          component: Sentimentssirona,
        },
      ],
    },
    {
      path: "/compliance-detail-timex",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "compliancedetailstimex",
          component: ComplianceDetailsTimex,
        },
      ],
    },
    {
      path: "/reviewslist",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Reviews",
          component: Reviewslist,
        },
      ],
    },
    {
      path: "/reviewlist-amd-india",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Reviews",
          component: ReviewslistAMDIndia,
        },
      ],
    },
    {
      path: "/reviews-list",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "ReviewslistAll",
          component: ReviewslistAll,
        },
      ],
    },
    {
      path: "/dashboard-vguard",
      component: DefaultContainer,
      children: [
        { path: "/", name: "DashboardVguard", component: DashboardVguard },
      ],
    },
    {
      path: "/sentiment-vguard",
      component: DefaultContainer,
      children: [
        { path: "/", name: "SentimentVguard", component: SentimentVguard },
      ],
    },
    {
      path: "/admin-sentiment-vguard",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "AdminSentimentVguard",
          component: AdminSentimentVguard,
        },
      ],
    },
    {
      path: "/complaints-vguard",
      component: DefaultContainer,
      children: [
        { path: "/", name: "ComplaintsVguard", component: ComplaintsVguard },
      ],
    },
    {
      path: "/sentiments-amd",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "sentimentsAmdIndia",
          component: SentimentsAmdIndia,
        },
      ],
    },
    {
      path: "/sentiments-amd-oem",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Sentiments",
          component: SentimentsAmdIndiaOEM,
        },
      ],
    },
    {
      path: "/audit",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Audit",
          component: Audit,
        },
      ],
    },
    {
      path: "/sentiments-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SentimentsDemo",
          component: SentimentsDemo,
        },
      ],
    },
    {
      path: "/sov-detailed-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVDetailedDemo",
          component: SOVDetailedDemo,
        },
      ],
    },
    {
      path: "/sov-summary-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVDemo",
          component: SOVDemo,
        },
      ],
    },
    {
      path: "/sovdetailed-demo-new",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVDetailNewDemo",
          component: SOVDetailNewDemo,
        },
      ],
    },
    {
      path: "/compliance-detail-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "ComplianceDetailsDemo",
          component: ComplianceDetailsDemo,
        },
      ],
    },
    {
      path: "/compliance-report-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "ComplianceReportDemo",
          component: ComplianceReportDemo,
        },
      ],
    },
    {
      path: "/messaging-report-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "ComplianceMessagingReportDemo",
          component: ComplianceMessagingReportDemo,
        },
      ],
    },
    {
      path: "/sov-detailed-demo-oem",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVDetailedOEMDemo",
          component: SOVDetailedOEMDemo,
        },
      ],
    },
    {
      path: "/reviewlist-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "ReviewslistDemo",
          component: ReviewslistDemo,
        },
      ],
    },
    {
      path: "/sentiments-demo-oem",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SentimentsOEMDemo",
          component: SentimentsOEMDemo,
        },
      ],
    },
    {
      path: "/sentiments-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SentimentsDemo",
          component: SentimentsDemo,
        },
      ],
    },
    {
      path: "/sov-detailed-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVDetailedDemo",
          component: SOVDetailedDemo,
        },
      ],
    },
    {
      path: "/sov-summary-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVDemo",
          component: SOVDemo,
        },
      ],
    },
    {
      path: "/sovdetailed-demo-new",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVDetailNewDemo",
          component: SOVDetailNewDemo,
        },
      ],
    },
    {
      path: "/compliance-detail-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "ComplianceDetailsDemo",
          component: ComplianceDetailsDemo,
        },
      ],
    },
    {
      path: "/compliance-report-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "ComplianceReportDemo",
          component: ComplianceReportDemo,
        },
      ],
    },
    {
      path: "/messaging-report-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "ComplianceMessagingReportDemo",
          component: ComplianceMessagingReportDemo,
        },
      ],
    },
    {
      path: "/sov-detailed-demo-oem",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SOVDetailedOEMDemo",
          component: SOVDetailedOEMDemo,
        },
      ],
    },
    {
      path: "/reviewlist-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "ReviewslistDemo",
          component: ReviewslistDemo,
        },
      ],
    },
    {
      path: "/sentiments-demo-oem",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "SentimentsOEMDemo",
          component: SentimentsOEMDemo,
        },
      ],
    },
    {
      path: "/price-demo",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "PriceDemo",
          component: PriceDemo,
        },
      ],
    },
    {
      path: "/availability-matrix",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Availability Tracking",
          component: IndiaGateDashboard,
        },
      ],
    },
    {
      path: "/price-tracking",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Price Tracking",
          component: PriceTracking,
        },
      ],
    },
    {
      path: "/",
      component: DefaultContainer,
      children: [
        {
          path: "price-tracking-disparity",
          name: "Price Tracking Disparity",
          component: PriceTrackingDisparity,
        },
        {
          path: "price-tracking-disparity/:productId",
          name: "Price Tracking",
          component: DisparityDetailsPage,
        },
      ],
    },

    {
      path: "/price-tracking-compare",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Price Tracking",
          component: PriceTrackingCompare,
        },
      ],
    },
    {
      path: "/lqs-analyser",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "LQS Analyzer ",
          component: LqsAnalyser,
        },
      ],
    },
    {
      path: "/lqs-schedule",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "LQS Analyzer",
          component: LqsSchedule,
        },
      ],
    },
    {
      path: "/view-lqs-request/:requestId/:channelName/:startDate/:endDate/:requestName",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "LQS Analyzer",
          component: ViewLqsRequest,
        },
      ],
    },
    {
      path: "/lqs-analyser-global",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Listing Analyser",
          component: LqsAnalyserGlobal,
        },
      ],
    },
    // {
    //   path: "/my-products",
    //   component: DefaultContainer,
    //   children: [
    //     {
    //       path: "/",
    //       name: "My Products",
    //       component: MyProducts,
    //     },
    //   ],
    // },
    {
      path: "/my-asins-global",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "My ASINs Global",
          component: MyASINsGlobal,
        },
      ],
    },
    {
      path: "/asins-detailed/:channel/:ASINId/:startDate/:endDate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "LQS Analyzer",
          component: ASINsDetailed,
        },
      ],
    },
    {
      path: "/fsns-detailed/:FSN/:startDate/:endDate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "LQS Analyzer",
          component: FSNsDetailed,
        },
      ],
    },
    {
      path: "/asins-compare/:channel/:compareASINs/:startDate/:endDate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "LQS Analyzer",
          component: ASINsCompare,
        },
      ],
    },
    {
      path: "/fsns-compare/:compareFSNs/:startDate/:endDate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "LQS Analyzer",
          component: FSNsCompare,
        },
      ],
    },
    {
      path: "/asins-detailed-global/:ASINId/:startDate/:endDate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "ASINs Detailed global",
          component: ASINsDetailedGlobal,
        },
      ],
    },
    {
      path: "/req-asins-detailed/:reqASINId/:startDate/:endDate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Requested ASINs Detailed",
          component: ReqASINsDetailed,
        },
      ],
    },
    {
      path: "/req-fsns-detailed/:reqFSNId/:startDate/:endDate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Requested FSNs Detailed",
          component: ReqFSNsDetailed,
        },
      ],
    },
    {
      path: "/req-asins-detailed-global/:reqId/:startDate/:endDate",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Requested ASINs Detailed Global",
          component: ReqASINsDetailedGlobal,
        },
      ],
    },
    {
      path: "/keyword-tracker",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Best Sellers Ranking",
          component: KeywordTracker,
        },
      ],
    },
    {
      path: "/buy-box-monitor",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Buybox Monitor",
          component: BuyBoxMonitor,
        },
      ],
    },
    {
      path: "/buybox-details",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Buybox Monitor",
          component: BuyBoxDetails,
        },
      ],
    },
    {
      path: "/phrase-analyser",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Phrase Analyser",
          component: PhraseAnalyser,
        },
      ],
    },
    {
      path: "/profile",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Account & Settings",
          component: ProfileDetail,
        },
      ],
    },
    {
      path: "/campaign-summary",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Campaign Summary",
          component: CampaignSummary,
        },
      ],
      // name: "AMS",
      // component: SlateAMS
    },
    {
      path: "/",
      component: DefaultContainer,
      children: [
        {
          path: "custom-report",
          name: "Custom Report",
          component: CustomReport,
        },
        {
          path: "custom-report/:type/:report_id",
          name: "Report",
          component: DynamicReport,
        },
      ],
    },
    // {
    //     path: "/report/:report_id",
    //     component: DefaultContainer,
    //     children: [
    //         {
    //             path: "/",
    //             name: "Report",
    //             component: PerformanceSummaryCustomReport
    //         }
    //     ]
    // },
    {
      path: "/alert",
      component: DefaultContainer,
      children: [
        {
          path: "",
          name: "Alert",
          component: Alert,
        },
      ],
    },
    // {
    //     path: "/summary",
    //     component: DefaultContainer,
    //     children: [
    //         {
    //             path: "/",
    //             name: "Summary",
    //             component: SlateSummary
    //         }
    //     ]
    // },
    {
      path: "/performance-summary",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Performance Summary",
          component: PerformanceSummary,
        },
      ],
    },
    {
      path: "/connect-your-account",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Connect Your Account",
          component: PlugNPlay,
        },
      ],
    },
    {
      path: "/connected-successfully",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Connection Successful",
          component: ConnectionSuccessful,
        },
      ],
    },
    {
      path: "/connected-failed",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Connection Failed",
          component: ConnectionFailed,
        },
      ],
    },
    {
      path: "/accounts",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Connect Your Account",
          component: Accounts,
        },
      ],
    },
    {
      path: "/vendor-summary",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Vendor Summary",
          component: VendorSummary,
        },
      ],
    },
    {
      path: "/warehouse-summary",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Warehouse Summary",
          component: warehouseSummary,
        },
      ],
    },
    {
      path: "/summary",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Summary",
          component: unicommerceSummary,
        },
      ],
    },
    {
      path: "/total-orders",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Total Orders",
          component: totalOrders,
        },
      ],
    },
     {
      path: "/grn-reco",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "GRN Reco",
          component: grnReco,
        },
      ],
    },
     {
      path: "/stock-planing",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Shiprocket Stock Planning Summary",
          component: stockPlanningSummary,
        },
      ],
    },
    {
      path: "/drr-report",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Daily Run Rate",
          component: drrReport,
        },
      ],
    },
     {
      path: "/upload-files",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "Upload Files",
          component: allUploadFile,
        },
      ],
    },
    {
      path: "/fc-summary",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "FC Summary",
          component: FCSummary,
        },
      ],
    },
    // {
    //     path: "/ams-analytics",
    //     name: "AMS Analytics",
    //     component: AMSAnalytics
    // },
    {
      path: "/user-management",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "User Management",
          component: UserManagement,
        },
      ],
    },
     {
      path: "/user-logs",
      component: DefaultContainer,
      children: [
        {
          path: "/",
          name: "User Logs",
          component: userLogs,
        },
      ],
    },
    {
      path: "/",
      component: DefaultContainer,
      name: "Reviews and Ratings",
      children: [
        {
          name: "Summary",
          path: "reviews/summary",
          component: ReviewSummary,
        },
        {
          name: "Brand Reviews",
          path: "reviews/brand",
          component: BrandReviews,
        },
        {
          name: "Category Reviews",
          path: "reviews/category",
          component: CategoryReviews,
        },
        {
          name: "Product Reviews",
          path: "reviews/product",
          component: newProductReviews,
        },
        // {
        //   name: "Product Reviews",
        //   path: "reviews/product_reviews",
        //   component: newProductReviews,
        // },
      ],
    },
    {
      path: "/sentiment/product",
      component: DefaultContainer,
      children: [
        {
          name: "Sentiments",
          path: "/",
          component: ProductSentiments,
        },
      ],
    },
    {
      path: "/weavrwise",
      component: DefaultContainer,
      children: [
        {
          name: "Weavrwise",
          path: "/",
          component: GenAiAsideBar,
        },
        // {
        //   name: "WeavrWise",
        //   path: "weavrwise/:platform",
        //   component: GenAiAsideBar,
        // },
      ],
    },

    {
      path: "*",
      component: DefaultContainer,
      children: [
        {
          name: "Not Found",
          path: "/",
          component: Page404,
        },
      ],
    },
  ];
}

const router = new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    window.location.reload();
  }
});

export default router;
